import { render, staticRenderFns } from "./punch-card-records.vue?vue&type=template&id=466e4012&scoped=true"
import script from "./punch-card-records.vue?vue&type=script&lang=js"
export * from "./punch-card-records.vue?vue&type=script&lang=js"
import style0 from "./punch-card-records.vue?vue&type=style&index=0&id=466e4012&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466e4012",
  null
  
)

export default component.exports